export const UserRoles = {
  ADMIN: 'ROLE_ADMIN',
  USER: 'ROLE_USER',
  PUBLIC: 'ROLE_PUBLIC',
};
